module.exports = __webpack_public_path__ + "static/img/ilustra_frente_rg.e9f45c7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/dicas-doc/ilustra_frente_rg.png
// module id = DWpY
// module chunks = 1